export { BlockRenderer } from './BlockRenderer';
export type { BlockRendererProps } from './registry';
export { getBlockRenderer, registerBlockRenderer } from './registry';
export type { Block, BlockMessage, BlockStatus, BlockType } from './types';

// Register built-in renderers
import { registerBlockRenderer } from './registry';
import { ApprovalBlockRenderer } from './renderers/ApprovalBlockRenderer';
import { ContentBlockRenderer } from './renderers/ContentBlockRenderer';
import { ErrorBlockRenderer } from './renderers/ErrorBlockRenderer';
import { PlanBlockRenderer } from './renderers/PlanBlockRenderer';
import { ThinkingBlockRenderer } from './renderers/ThinkingBlockRenderer';
import { ToolStatusBlockRenderer } from './renderers/ToolStatusBlockRenderer';

registerBlockRenderer('content', ContentBlockRenderer);
registerBlockRenderer('thinking', ThinkingBlockRenderer);
registerBlockRenderer('plan', PlanBlockRenderer);
registerBlockRenderer('tool_status', ToolStatusBlockRenderer);
registerBlockRenderer('approval', ApprovalBlockRenderer);
registerBlockRenderer('error', ErrorBlockRenderer);
